export enum EStatus {
  inProgress = "In Progress",
  won = "Won",
  dropped = "Dropped",
  lost = "Lost"
}
